import { contactv2_DynamicFieldOption } from "src/api"

/**
 * Shallow equality check for metadata objects.
 * Compares keys and values using strict equality (===).
 * Handles property order differences that can occur when saving/loading from backend.
 * Note: Only suitable for flat objects with primitive values (e.g., Record<string, string>).
 */
const isMetadataEqual = (
    a: Record<string, unknown>,
    b: Record<string, unknown>,
): boolean => {
    const aKeys = Object.keys(a).sort()
    const bKeys = Object.keys(b).sort()
    if (aKeys.length !== bKeys.length) return false
    return aKeys.every((key, i) => key === bKeys[i] && a[key] === b[key])
}

/**
 * Find option index by metadata equality.
 * Returns the index of the option with matching metadata, or -1 if not found.
 */
export const findOptionIndexByMetadata = (
    options: contactv2_DynamicFieldOption[],
    targetMetadata: Record<string, unknown>,
): number => {
    return options.findIndex((opt) =>
        isMetadataEqual(opt.metadata, targetMetadata),
    )
}
